export const DATATEST = {
    ROOT: "reusable__loading-indicator-component",
};
